export const getInitials = (name) => {
  const initials = String(name)
    .split(" ")
    .map((word) => word.charAt(0))
    .join("");
  return initials;
};

export const px2Rem = (px) => `${px / 16}rem`;

export const boldedText = (text, shouldBeBold) => {
  const textArray = text.split(shouldBeBold);
  return (
    <span>
      {textArray.map((item, index) => (
        <>
          {item}
          {index !== textArray.length - 1 && <b>{shouldBeBold}</b>}
        </>
      ))}
    </span>
  );
};

export const capitalize = (str) => {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return splitStr.join(" ");
};

export const sortArrayOfObjectsByProperty = (a, b) => {
  if (parseFloat(a.price) < parseFloat(b.price)) {
    return -1;
  } else if (parseFloat(a.price) > parseFloat(b.price)) {
    return 1;
  }
  return 0;
};

export const cc_expires_format = (value) => {
  return value
    .replace(/[^0-9]/g, "")
    .replace(/^([2-9])$/g, "0$1")
    .replace(/^(1{1})([3-9]{1})$/g, "0$1/$2")
    .replace(/^0{1,}/g, "0")
    .replace(/^([0-1]{1}[0-9]{1})([0-9]{1,2}).*/g, "$1/$2");
};

export const numeric_format = (value) => {
  return value
    .replace(/[^0-9.]/g, "")
    .replace(/^(\d*\.)(.*)$/, (match, p1, p2) => p1 + p2.replace(/\./g, ""))
    .replace(/^0+(\d)/, "$1")
    .replace(/^\./, "0.");
};

export const letters_format = (value) => {
  if (!value) return "";

  return value
    .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, "")
    .replace(/\s+/g, " ")
    .replace(/^\s+/, "");
};

export const numbers_only_format = (value) => {
  return value.replace(/[^0-9]/g, "").replace(/^0+(\d)/g, "$1");
};
